(function(module) {

    "use strict";

    /**
     * Simple include, this directive exists purely as a performance improvement, ng-include assigns the
     * template to the innerHTML of the element every time it is used, causing the browser to repeatedly
     * parse the template. This is much less efficient than jqlite's clone function
     */
    module.directive("simpleInclude", ["$compile", "$templateRequest", function($compile, $templateRequest) {

        return {
            restrict: "AE",
            compile: function(_, $attr) {
                var template = $templateRequest($attr.src, true).then(function(template) {
                    return angular.element(template);
                });
                return function($scope, $element) {
                    template.then(function($template) {
                        var clone = $template.clone();
                        $element.append(clone);
                        $compile(clone)($scope);
                    });
                };
            }
        };

    }]);

})(angular.module("vhols"));